var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1813 14.9609L19.2363 4.50893C18.225 2.73438 16.6152 1.78571 14.9827 1.78571C13.9579 1.78571 12.9194 2.1596 12.0125 2.94085C11.1191 3.71094 10.4843 4.77121 10.1306 5.94308C9.99905 2.63393 7.79971 0 5.07888 0C2.27189 0 0 2.79576 0 6.25V18.75C0 22.2042 2.27189 25 5.07888 25C7.88587 25 10.1578 22.2042 10.1578 18.75V10.4297C10.3074 10.9096 10.4888 11.3839 10.7382 11.8248L16.6878 22.2768C17.6945 24.0513 19.3043 25 20.9413 25C21.9707 25 23.0046 24.6261 23.9116 23.8449C26.256 21.8248 26.8228 17.846 25.1813 14.9609ZM7.25555 12.5H2.90222V6.25C2.90222 4.77121 3.87718 3.57143 5.07888 3.57143C6.28058 3.57143 7.25555 4.77121 7.25555 6.25V12.5ZM16.0892 15.0056L13.1144 9.77679C12.7652 9.16295 12.6292 8.41518 12.738 7.67857C12.8423 6.94196 13.1779 6.29464 13.6767 5.86496C14.0622 5.53013 14.5156 5.35714 14.9827 5.35714C15.7309 5.35714 16.4293 5.80357 16.8555 6.55692L19.8303 11.7857L16.0892 15.0056Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharma);
export default __webpack_public_path__ + "static/media/pharma.07e43e3b7d532859aa33b176e7280868.svg";
export { ForwardRef as ReactComponent };